import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import { FaPlay } from 'react-icons/fa';
import Modal from './Modal';
import ProjectImg from './assets/images/projectImg.webp';



export default function ProjectItem(
  {
  img = ProjectImg,
  img2 = ProjectImg,
  imgVideo = false,
  img2Video = false,
  title = 'Project Name',
  desc = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  desc2 = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  url = '',
  tool1 ='',
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {t} = useTranslation(['projects']);

  return (
    <ProjectItemStyles>
      <Modal
        isOpen={isModalOpen}
        onClose={setIsModalOpen}
        title={t(title)}
        showHeader={true}
        showOverlay={true}
        alignment={'center'}
        padding={'20px'}
      >
        <ModalBody>
          <div className="modal__media">
            {(() => {
              const media = img2Video ? (
                <video src={img2} autoPlay loop muted playsInline />
              ) : (
                <img border="0" src={img2} alt={t(title)} loading="lazy" />
              );
              return url !== "#!" ? (
                <a href={url} target="_blank" rel="noreferrer">
                  {media}
                  <span className="modal__media-badge"><FaPlay /> {t("watchfullvideo")}</span>
                </a>
              ) : media;
            })()}
          </div>
          <div className="modal__meta">
            <div className="modal__text">
              <p>{t(desc)}</p>
              <p>{t(desc2)}</p>
            </div>
            <div className="modal__tools">
              <p className="tooltitle">{t("tools")}</p>
              <div className="svgtool">{tool1}</div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <button
        type="button"
        className="projectItem__trigger"
        onClick={() => setIsModalOpen(true)}
        aria-label={`${t("viewproject")}: ${t(title)}`}
      >
        <div className="projectItem__media">
          {imgVideo ? (
            <video src={img} autoPlay loop muted playsInline />
          ) : (
            <img src={img} alt="" loading="lazy" />
          )}
        </div>
        <div className="projectItem__overlay">
          <h3 className="projectItem__title">{t(title)}</h3>
          <span className="projectItem__cta">{t("viewproject")}</span>
        </div>
      </button>
    </ProjectItemStyles>
  );
}
const ModalBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;

	.modal__media {
		width: 100%;
		max-height: min(50vh, 460px);
		border-radius: var(--radius-md);
		overflow: hidden;
		background-color: var(--dark-footer);
		border: 1px solid var(--border-subtle);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.modal__media img,
	.modal__media video,
	.modal__media a {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.modal__media img,
	.modal__media video {
		max-width: 100%;
		max-height: min(50vh, 460px);
		width: auto;
		height: auto;
		object-fit: contain;
		display: block;
	}
	.modal__media a {
		position: relative;
	}
	.modal__media-badge {
		position: absolute;
		bottom: 12px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		align-items: center;
		gap: 6px;
		background: rgba(0, 0, 0, 0.65);
		color: #fff;
		font-size: var(--fs-xs);
		font-weight: 600;
		padding: 6px 12px;
		border-radius: var(--radius-pill);
		backdrop-filter: blur(4px);
		transition: 0.3s ease-in-out;
		white-space: nowrap;
	}
	.modal__media-badge svg {
		width: 0.8em;
		height: 0.8em;
	}
	.modal__media a:hover .modal__media-badge {
		background: var(--hover-accent);
		color: var(--dark-background);
	}

	.modal__meta {
		display: flex;
		align-items: flex-start;
		gap: 3rem;
	}
	.modal__text {
		flex: 1;
		min-width: 0;
	}
	.modal__text p {
		font-size: var(--fs-base);
		margin-bottom: 1rem;
	}
	.modal__text p:last-child {
		margin-bottom: 0;
	}
	.modal__tools {
		flex: 0 0 180px;
		border-left: 1px solid var(--border-subtle);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.75rem;
	}
	.tooltitle {
		font-family: var(--font-mono);
		font-size: var(--fs-md);
		font-weight: 600;
		letter-spacing: 0.05em;
		text-transform: uppercase;
		color: var(--accent-strong, var(--accent));
		text-align: center;
	}
	.svgtool {
		justify-content: center;
		flex-wrap: wrap;
	}

	@media only screen and (max-width: 850px) {
		.modal__media {
			max-height: 260px;
		}
		.modal__media img,
		.modal__media video {
			max-height: 260px;
		}
		.modal__meta {
			flex-direction: column;
			gap: 1.5rem;
		}
		.modal__text p {
			font-size: var(--fs-sm);
		}
		.modal__tools {
			flex: 1;
			width: 100%;
			padding-left: 0;
			padding-top: 1.5rem;
			border-left: none;
			border-top: 1px solid var(--border-subtle);
		}
	}
`;


const ProjectItemStyles = styled.div`
  height: 100%;

  .projectItem__trigger {
    position: relative;
    display: block;
    width: 100%;
    aspect-ratio: 4 / 5;
    padding: 0;
    margin: 0;
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    overflow: hidden;
    background: var(--dark-footer);
    cursor: pointer;
    outline: none;
  }

  .projectItem__trigger:focus-visible {
    border-color: var(--accent-strong, var(--accent));
  }

  .projectItem__media {
    position: absolute;
    inset: 0;
  }

  .projectItem__media img,
  .projectItem__media video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s ease;
  }

  .projectItem__trigger:hover .projectItem__media img,
  .projectItem__trigger:hover .projectItem__media video,
  .projectItem__trigger:focus-visible .projectItem__media img,
  .projectItem__trigger:focus-visible .projectItem__media video {
    transform: scale(1.05);
  }

  .projectItem__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    text-align: left;
    padding: 1.5rem;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.35) 45%,
      rgba(0, 0, 0, 0) 75%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .projectItem__trigger:hover .projectItem__overlay,
  .projectItem__trigger:focus-visible .projectItem__overlay {
    opacity: 1;
  }

  .projectItem__title {
    color: #fff;
    font-size: var(--fs-lg);
    font-weight: 600;
    margin: 0;
  }

  .projectItem__cta {
    margin-top: 0.4rem;
    font-family: var(--font-mono);
    font-size: var(--fs-xs);
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--accent);
  }

  @media (prefers-reduced-motion: reduce) {
    .projectItem__media img,
    .projectItem__media video {
      transition: none;
    }
  }

  @media (hover: none) {
    .projectItem__overlay {
      opacity: 1;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.75) 0%,
        rgba(0, 0, 0, 0) 60%
      );
    }
    .projectItem__trigger:hover .projectItem__media img,
    .projectItem__trigger:hover .projectItem__media video {
      transform: none;
    }
  }
`;
